import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 318 238.29"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "m257.674 8.912-37.252 104.872-36.29-100.57c-8.302.253-16.601.403-25.206.403-8.452 0-16.754-.153-25.053-.253L97.43 113.832 60.077 8.809C38.01 6.632 17.818 3.696 0 .053l94.698 236.013c.658-.151 1.215-.151 1.62-.151 4.301-7.237 48.739-89.08 48.739-89.08l.254-.811c1.316-1.062 2.935-2.024 4.808-2.835 10.022-4.151 10.73-5.213 3.19-4.151a21.6 21.6 0 0 0-6.986 2.431l8.452-34.164-21.106-38.82 54.511 43.376s-1.62 22.775 2.431 22.775c3.746 0 2.023 10.172 1.72 15.388-1.316-.811-3.089-1.72-4.809-3.089-2.278-1.873-3.34-3.746-3.747-4.708.405 1.469 1.316 4.404 2.682 6.986 1.316 2.428 5.213 5.617 7.087 7.237 3.088 10.021 11.134 32.797 18.624 53.702-1.062-.658-2.428-1.469-3.897-2.127-7.39-3.747-22.22-17.412-24.091-19.132 4.708 7.39 6.275 10.021 10.983 14.981 3.897 4.301 15.285 12.857 20.752 16.854l.15.151c2.278 6.275 4.405 12.299 6.276 17.412L318 0c-17.862 3.696-38.058 6.632-60.326 8.912",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }